import { on, ready, query } from './dom.js'

/* * /
import {
  Matrix4, Vector3, WebGLRenderer, JSONLoader, CubeTextureLoader, Mesh,
  Object3D, MeshPhongMaterial, SphereGeometry, Scene, OrthographicCamera,
  AmbientLight, DirectionalLight, AmbientLight, RGBFormat, MixOperation as M
} from 'three/Three.js'
/* */
import { Matrix4 } from 'three/math/Matrix4.js'
import { Vector3 } from 'three/math/Vector3.js'

import { WebGLRenderer } from 'three/renderers/WebGLRenderer.js'

import { JSONLoader }        from 'three/loaders/JSONLoader.js'
import { CubeTextureLoader } from 'three/loaders/CubeTextureLoader.js'

import { Mesh } from 'three/objects/Mesh.js'

import { Object3D } from 'three/core/Object3D.js'

import { MeshPhongMaterial } from 'three/materials/MeshPhongMaterial.js'

import { SphereGeometry } from  'three/geometries/SphereGeometry.js'

import { Scene } from 'three/scenes/Scene.js'

import { OrthographicCamera } from 'three/cameras/OrthographicCamera.js'

import { AmbientLight }     from 'three/lights/AmbientLight.js'
import { DirectionalLight } from 'three/lights/DirectionalLight.js'

import { RGBFormat, MixOperation as M } from 'three/constants.js'
/* */

export const MixOperation = M
export function ScrewScene(selector, screwUrl, phong){
    var container, renderer;

    var scene, camera, material, screw, group;

    var light1, light2;

    var targetRotationX = -Math.PI/4;
    var targetRotationOnMouseDownX = 0;

    var targetRotationY = -Math.PI/4;
    var targetRotationOnMouseDownY = 0;

    var targetZoom = 1;
    var currentTargetZoom;

    var initialZoom = 2.5;

    var mouseXOnMouseDown = 0;
    var mouseYOnMouseDown = 0;


    var offContainerMouseMove, offContainerMouseUp, offContainerMouseOut;
    var offContainerTouchMove, offContainerTouchEnd, offContainerTouchLeave;

    var fovWidth;
    var fovHeight;

    var width, height = 10, radius, zoom;

    var cameraX = height;

    var oneDegree = Math.PI / 180;

    var touch_started = false;

    var d0;

    var scaleUp = 1.05;

    var mat = new Matrix4();

    var animationMode = 'auto';
    var lastUserAction;
    var delayAfterUserAction= 3000;

    var container = query(selector);
    var cubemap;

    var self = this;

    var autoAnimEnabled = true;
    var userZoomEnabled = true;
    var userRotateEnabled = true;

    var paused = true;
    var animInitState = {
      targetRotY: Math.PI/3,
      targetZoom: 1,
    };

    var animationRule = function(params){
      return {
        targetRotX: params.rotX + Math.PI/6
      };
    }

    function startAutoAnimate(){
      self.setAnimState(animInitState);
    }

    this.setAnimInitState = function(params){
      animInitState = params;
    }

    this.autoAnimate = function(animate){
      autoAnimEnabled = animate;
      if(animate){
        animationMode='auto';
        startAutoAnimate();
      } else {
        animationMode='user';
      }
    };

    this.userZoom = function(interact){
      userZoomEnabled = interact;
    };

    this.userRotate = function(interact){
      userRotateEnabled = interact;
    };

    this.userInteract = function(interact){
      userZoomEnabled = interact;
      userRotateEnabled = interact;
    };

    this.pause = function(){
      paused = true;
    };

    this.start = function(){
      if(paused){
        requestAnimationFrame(animate, 0);
      }
      paused = false;
    };

    this.radius = function(){
      return screw.geometry.boundingSphere.radius;
    };

    this.animationFrame = function(){
      render();
    };

    this.setAnimDelay = function(delay){
      delayAfterUserAction = delay;
    };

    function loadSkymap(){
      var sky_urls = [
        'images/threejs/skybox/tropicalsunny/sky-pos-x.jpg',
        'images/threejs/skybox/tropicalsunny/sky-neg-x.jpg',
        'images/threejs/skybox/tropicalsunny/sky-pos-y.jpg',
        'images/threejs/skybox/tropicalsunny/sky-neg-y.jpg',
        'images/threejs/skybox/tropicalsunny/sky-pos-z.jpg',
        'images/threejs/skybox/tropicalsunny/sky-neg-z.jpg'
      ];

      var loader = new CubeTextureLoader()
      cubemap = loader.load(sky_urls)

      cubemap.format = RGBFormat;
    }

    this.setPhong = function(phong){
      phong.reflectivity*= 1.5 //TODO: Dies sollte außerhalb geschehen.
      phong.combine = MixOperation
      delete phong.ambient
      if (cubemap) {
        phong.envMap = cubemap
      }

      material = new MeshPhongMaterial(phong);
      if(screw){
        screw.material = material;
      }
    }

    this.loadMesh = function(screwUrl){
      var loader = new JSONLoader();
      loader.load(screwUrl, function (geometry2) {
        geometry2.center();
        geometry2.computeBoundingSphere();
        var screw2 = new Mesh(geometry2, screw.material);
        var radius2 = geometry2.boundingSphere.radius;
        var radius1 = screw.geometry.boundingSphere.radius;
        screw2.scale.multiplyScalar(radius1/radius2);
        screw2.rotation.x = screw.rotation.x;
        screw2.rotation.y = screw.rotation.y;
        screw2.rotation.z = screw.rotation.z;
        scene.remove(screw);
        scene.add(screw2);
        screw.geometry.dispose();
        //screw.dispose();
        screw = screw2;
      });
    }

    this.getAnimState = function(){
      return {
        zoom: zoom/initialZoom,
        targetZoom: targetZoom/initialZoom,
        rotX: group.rotation.y,
        rotY: group.rotation.x,
        targetRotX: targetRotationX,
        targetRotY: targetRotationY,
      };
    };

    this.setAnimState = function(params){
      if(params.hasOwnProperty('zoom')){
        zoom = parseFloat(params.zoom * initialZoom);
      }
      if(params.hasOwnProperty('targetZoom')){
        targetZoom = parseFloat(params.targetZoom * initialZoom);
      }
      if(params.hasOwnProperty('rotX')){
        group.rotation.y = parseFloat(params.rotX);
      }
      if(params.hasOwnProperty('rotY')){
        group.rotation.x = parseFloat(params.rotY);
      }
      if(params.hasOwnProperty('targetRotX')){
        targetRotationX = parseFloat(params.targetRotX);
      }
      if(params.hasOwnProperty('targetRotY')){
        targetRotationY = parseFloat(params.targetRotY);
      }
    };

    this.setAnimationRule = function(callback){
      animationRule = callback;
    }

    function init (screwUrl, phong) {
      scene = new Scene();

      width = fovWidth / (fovHeight / height);

      //camera
      camera = new OrthographicCamera(-width/2, width/2, height/2, -height/2, 0.1, 10000);
      camera.position.set(cameraX, 0, 0);
      camera.lookAt(new Vector3());

      // lights
      light1 = new DirectionalLight(0xffffff);
      light1.position.set(height, height, -height);
      scene.add(light1);
      light2 = new AmbientLight(0x222222);
      scene.add(light2);

      group = new Object3D();
      group.add(light1);
      group.add(light2);
      group.add(camera);

      scene.add(group);

      // renderer
      renderer = new WebGLRenderer({ antialias: true, alpha: true });
      renderer.setSize(fovWidth, fovHeight);

      // Set the background color of the scene.
      renderer.setClearColor(0xffffff, 1);

      // load screw
      var loader = new JSONLoader();
      loader.load(screwUrl, function (geometry) {
        //geometry = new SphereGeometry(5, 32, 32);
        geometry.center();

        geometry.computeBoundingSphere();
        radius = geometry.boundingSphere.radius;

        zoom = initialZoom;

        loadSkymap();
        self.setPhong(phong);

        screw = new Mesh(geometry, material);
        screw.scale.multiplyScalar(zoom/radius);
        screw.rotation.x =  Math.PI / 2;

        //var initialZoomFactor = 0.01
        //zoom *= initialZoomFactor;

        scene.add(screw);

        startAutoAnimate();

        updateCamera();
        renderer.render(scene, camera);
      });

      container.appendChild(renderer.domElement);

      /* event handler */
      on(container, 'mousedown', onContainerMouseDown)
      on(container, 'wheel', onContainerMouseWheel)
      on(container, 'touchstart', onContainerTouchStart)
      /* */
    }

    function userAction(){
      animationMode='user';
      var now = new Date()
      lastUserAction=now.getTime();
    }

    function onContainerMouseDown(event) {
      event.preventDefault();
      if(paused){
        return;
      }
      if(!userRotateEnabled){
        return;
      }
      userAction();

      var fovX = (event.pageX - container.offsetLeft).toFixed(0);
      var fovY = (event.pageY - container.offsetTop).toFixed(0);

      mouseXOnMouseDown = fovX - fovWidth/2;
      targetRotationOnMouseDownX = targetRotationX;

      mouseYOnMouseDown = fovY - fovHeight/2;
      targetRotationOnMouseDownY = targetRotationY;

      offContainerMouseMove = on(container, 'mousemove', onContainerMouseMove)
      offContainerMouseUp = on(container, 'mouseup', onContainerMouseUp)
      offContainerMouseOut = on(container, 'mouseout', onContainerMouseOut)
    }

    function onContainerMouseMove (event) {
      event.preventDefault();
      if(paused){
        return;
      }
      if(!userRotateEnabled){
        return;
      }
      userAction();

      var fovX = (event.pageX - container.offsetLeft).toFixed(0);
      var fovY = (event.pageY - container.offsetTop).toFixed(0);

      var mouseX = fovX - fovWidth/2;
      var mouseY = fovY - fovHeight/2;

      targetRotationX = targetRotationOnMouseDownX - (mouseX - mouseXOnMouseDown) * oneDegree;
      targetRotationY = targetRotationOnMouseDownY + (mouseY - mouseYOnMouseDown) * oneDegree;

      targetRotationY = Math.max(targetRotationY, 0);
      targetRotationY = Math.min(targetRotationY, Math.PI);
    }

    function onContainerMouseUp (event) {
      event.preventDefault();
      userAction();
      offContainerMouseMove();
      offContainerMouseUp();
      offContainerMouseOut();
    }

    function onContainerMouseOut (event) {
      event.preventDefault();
      offContainerMouseMove();
      offContainerMouseUp();
      offContainerMouseOut();
    }

    function onContainerMouseWheel (event) {
      event.preventDefault();
      if(paused){
        return;
      }
      if(!userZoomEnabled){
        return;
      }
      userAction();

      targetZoom *= Math.pow(scaleUp, event.deltaY/10);
    }

    function initTouchRotation(event){
      if(paused){
        return;
      }
      if(!userRotateEnabled){
        return;
      }
      userAction();
      var fovX = (event.touches[0].pageX - container.offsetLeft).toFixed(0);
      var fovY = (event.touches[0].pageY - container.offsetTop).toFixed(0);

      mouseXOnMouseDown = fovX - fovWidth/2;
      targetRotationOnMouseDownX = targetRotationX;

      mouseYOnMouseDown = fovY - fovHeight/2;
      targetRotationOnMouseDownY = targetRotationY;
    }

    function performTouchRotation(event){
      if(paused){
        return;
      }
      if(!userRotateEnabled){
        return;
      }
      userAction();
      var fovX = (event.touches[0].pageX - container.offsetLeft).toFixed(0);
      var fovY = (event.touches[0].pageY - container.offsetTop).toFixed(0);

      var mouseX = fovX - fovWidth/2;
      var mouseY = fovY - fovHeight/2;

      targetRotationX = targetRotationOnMouseDownX - (mouseX - mouseXOnMouseDown) * oneDegree;
      targetRotationY = targetRotationOnMouseDownY + (mouseY - mouseYOnMouseDown) * oneDegree;

      targetRotationY = Math.max(targetRotationY, 0);
      targetRotationY = Math.min(targetRotationY, Math.PI);
    }

    function sqr(x){
      return x*x;
    }

    function initTouchZoom(event){
      if(!userZoomEnabled){
        return;
      }
      userAction();
      d0 = Math.sqrt(sqr(event.touches[0].pageX-event.touches[1].pageX)+sqr(event.touches[0].pageY-event.touches[1].pageY))
      currentTargetZoom = targetZoom;
    }

    function performTouchZoom(event){
      if(!userZoomEnabled){
        return;
      }
      userAction();
      var zoomfactor = Math.sqrt(sqr(event.touches[0].pageX-event.touches[1].pageX)+sqr(event.touches[0].pageY-event.touches[1].pageY))/d0;
      targetZoom *= zoomfactor;
    }

    function onContainerTouchStart (event) {
      event.preventDefault();
      if(paused){
        return;
      }
      switch(event.touches.length) {
        case 1:
          initTouchRotation(event);
          break;
        case 2:
          initTouchZoom(event);
          break;
      }
      if(!touch_started){
        touch_started = true;
        offContainerTouchMove = on('touchmove', container, onContainerTouchMove)
        offContainerTouchEnd = on('touchend', container, onContainerTouchEnd)
        offContainerTouchLeave = on('touchleave', container, onContainerTouchLeave)
      }
    }

    function onContainerTouchMove (event) {
      event.preventDefault();
      if(paused){
        return;
      }
      switch(event.touches.length) {
        case 1:
          performTouchRotation(event);
          break;
        case 2:
          performTouchZoom(event);
          break;
      }
    }

    function onContainerTouchEnd(event) {
      event.preventDefault();
      switch(event.touches.length) {
        case 0:
          offContainerTouchMove();
          offContainerTouchEnd();
          offContainerTouchLeave();
          touch_started = false;
          break;
        case 1:
          initTouchRotation();
        case 2:
          initTouchZoom();
      }
    }

    function onContainerTouchLeave(event) {
      event.preventDefault();
      offContainerTouchMove();
      offContainerTouchEnd();
      offContainerTouchLeave();
      touch_started = false;
    }

    // Animate Loop
    function animate() {
      if(paused){
        return;
      }
      requestAnimationFrame(animate);
      render();
    }

    function updateCamera(){
      camera.left = -width / zoom;
      camera.right = width / zoom;
      camera.top = height / zoom;
      camera.bottom = - height / zoom;
      camera.updateProjectionMatrix();
    }

    function render() {
      var change = false;

      // Rotate Y
      if (Math.abs(targetRotationX - group.rotation.y) > 0.01) {
        group.rotation.y += ( targetRotationX - group.rotation.y ) * (oneDegree * 2.0);
        change = true;
      }

      // Rotate Z
      if (Math.abs(targetRotationY - group.rotation.x) > 0.01) {
        group.rotation.x += ( targetRotationY - group.rotation.x ) * (oneDegree * 4.0);
        change = true;
      }

      //Scale Up/Down
      if(targetZoom != zoom){
        if (targetZoom > zoom*scaleUp) {
          zoom *= scaleUp;
        } else if(targetZoom < zoom/scaleUp){
          zoom /= scaleUp;
        } else {
          zoom = targetZoom;
        }
        updateCamera();
        change = true;
      }

      if(animationMode == 'user'){
        var now = new Date();
        if(autoAnimEnabled && (now.getTime() > lastUserAction + delayAfterUserAction)){
          animationMode = 'auto';
          startAutoAnimate();
        }
      }

      if(animationMode == 'auto'){
        self.setAnimState(animationRule(self.getAnimState()));
      }

      if (change) {
        renderer.render(scene, camera);
      }
    }


    fovWidth = container.offsetWidth;
    fovHeight = container.offsetHeight;
    init(screwUrl, phong);
    requestAnimationFrame(animate);
    return this;
  }
